import Input from './Input'
import ValidatorEngine from 'validatorjs'
export default class Page {
	constructor (page, validator) {
		this.pageElement = page
		this.Action = validator.ActionClass
		this.validator = validator
		this.labelList = this.getlabelList()
		this.inputs = this.getInputs()
		this.actionList = this.getActionList()
		this.actionButton = {}
		this.sequence = page.getAttribute('data-page')
		this.createSchema()
	}

	createSchema () {
		let rules = {};
		[...this.pageElement.querySelectorAll('[data-validate]')].forEach(input => {
			rules[input.name] = input.getAttribute('data-validate')
		})
		this.schema = rules
	}

	getlabelList () {
		let label = {};
		[...this.pageElement.querySelectorAll('[data-validate]')].forEach(input => {
			label[input.name] = input.getAttribute('data-label')
		})
		return label
	}

	getInputs () {
		let fields = [];
		[...this.pageElement.querySelectorAll('[data-validate]')].forEach(input => {
			fields.push(new Input(input, this))
		})
		return fields
	}

	getActionList () {
		let actionBar = [...this.pageElement.querySelectorAll('[data-action]')]
		let actionList = []
		let Action = this.Action;
		[...actionBar].forEach(button => {
			let actionName = button.getAttribute('data-action')
			let event = button.hasAttribute('data-action-event') ? button.getAttribute('data-action-event') : 'click'
			actionList.push(new Action(actionName, this, event))
		})
		if (actionList.length === 0) { console.warn('Warning this page does not contain any action!') }
		return actionList
	}

	closePage () {
		this.validator.eventHandlers.closePage(this.pageElement)
	}
	openPage () {
		this.validator.eventHandlers.openPage(this.pageElement)
	}

	getValues () {
		let data = {};
		[...this.inputs].forEach(input => {
			data[input.name] = input.getValue()
		})
		return data
	}

	submitForm () {
		if (this.validator.eventHandlers.submitForm()) { this.validator.submitForm() }
	}

	setErrors (errors, validBeforeSubmit) {
		this.errors = errors
		this.inputs.forEach(input => {
			input.onErrorsChanged(validBeforeSubmit)
		})
	}

	validateInput () {
		this.validate(false).then(value => {
			if (value) {
				[...this.actionList].forEach(action => {
					action.unlockAction()
				})
			} else {
				[...this.actionList].forEach(action => {
					action.disableAction()
				})
			}
		})
			.catch(value => {
				console.error(value)
			})
	}

	validate (validBeforeSubmit = true) {
		let _this = this
		return new Promise(resolve => {
			[..._this.validator.customRules].forEach(rule => {
				ValidatorEngine.register(rule.name, rule.callbackFn, rule.errorMessage)
			});

			[..._this.validator.asyncRules].forEach(rule => {
				ValidatorEngine.registerAsync(rule.name, rule.callbackFn)
			})

			ValidatorEngine.useLang(this.validator.lang)

			let langList = {}

			if (this.validator.langList[this.validator.lang]) {
				langList = 	this.validator.langList[this.validator.lang].getLangList()
			} else {
				langList = this.validator.getMessages('lang_code') //! Sprawdź to!
			}

			ValidatorEngine.setMessages(this.validator.lang, langList)

			let validation = new ValidatorEngine(this.getValues(), this.schema)
			validation.setAttributeNames(this.labelList)
			validation.passes(() => {
				this.setErrors(validation.errors, validBeforeSubmit)
				resolve(true)
			})
			validation.fails(() => {
				this.setErrors(validation.errors, validBeforeSubmit)
				resolve(false)
			})
		})
	}
}



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/validation/Page.js